import type { LucideIcon } from "lucide-react";
import { Clock } from "@/components/animate-ui/icons/clock";
import { PlugZap } from "@/components/animate-ui/icons/plug-zap";

/**
 * Icon component type that supports optional animateOnHover prop
 */
type IconComponent = LucideIcon | React.ComponentType<{ animateOnHover?: boolean }>;

/**
 * Navigation item definition
 */
export interface NavItem {
	title: string;
	url: string;
	icon: IconComponent;
}

/**
 * Main navigation items (primary sidebar menu)
 */
export const NAV_MAIN_ITEMS: NavItem[] = [
	{
		title: "Automations",
		url: "/automations",
		icon: Clock,
	},
	{
		title: "Apps",
		url: "/integrations",
		icon: PlugZap,
	},
];

/**
 * Secondary navigation items (bottom sidebar menu)
 */
export const NAV_SECONDARY_ITEMS: NavItem[] = [];
